// TODO: Make tooltip reusable component. See _badge.vue
export default {
  data: function data() {
    return {
      tooltip: {}
    };
  },
  methods: {
    $initAccessories: function $initAccessories() {
      this.tooltip = this.spec.tooltip || {
        disabled: true
      };
    },
    tooltipPositionMatches: function tooltipPositionMatches(position) {
      if (this.spec.tooltip && this.spec.tooltip.position) {
        return position == this.spec.tooltip.position;
      } else {
        return position == "bottom";
      }
    }
  }
};